var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZhihuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4267B2;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#C2191E;}\n\t.st4{fill:#1DA1F3;}\n\t.st5{fill:#FEFE00;}\n\t.st6{fill:#25D366;stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}\n\t.st7{fill:#CB2027;}\n\t.st8{fill:#0077B5;}\n\t.st9{fill:url(#SVGID_2_);}\n\t.st10{fill:url(#SVGID_3_);}\n\t.st11{fill:#FF004F;}\n\t.st12{fill:#00F7EF;}\n\t.st13{fill:#5181B8;}\n\t.st14{fill:#395976;}\n\t.st15{fill:#F58220;}\n\t.st16{fill:#E6162D;}\n\t.st17{fill:#FF9933;}\n\t.st18{fill:#FF4500;}\n\t.st19{fill:#0F88EB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "guidlines"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "FB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ig"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "yt"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "twitter"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "snapchat"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "WA"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Pinterrest"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M50,62H14C7.3725829,62,2,56.6274185,2,50V14C2,7.3725829,7.3725829,2,14,2h36    c6.6274185,0,12,5.3725829,12,12v36C62,56.6274185,56.6274185,62,50,62z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.2162476,38.015625l-1.713501,1.3327026c0.3545532-1.5984497,0.6206055-3.3781128,0.8196411-5.1764526     h8.0188599c0-2.96875-1.0535889-3-1.0535889-3s-3.1391602,0-6.690979,0     c0.3748169-5.0420532,0.3070679-9.479187,0.3070679-9.479187h6.6875v-1.1315308     c0-0.9068604-0.7351074-1.6419678-1.6419678-1.6419678H19.7702637l0,0l1.8209839-5.4973135     c-1.5-0.0625-3.4375,0.625-4.375,3.499999s-3.75,9.5-3.75,9.5c3.75,0,4.8125-3,4.8125-3l0.5728149-1.729187l0,0h3.8021851     l-0.0625,9.479187c-3.1615601,0-6.0524902,0-6.78125,0c-1.78125,0-2.15625,3-2.15625,3h8.5845947     c-1.8969116,11.9562988-9.3345947,16.3125-9.3345947,16.3125c6.125,0.5625,7.125-1.25,10.1875-6.9375     c0.4821167-0.8953857,0.881897-2.0510864,1.2137451-3.3619385l6.7550049,8.3619385c0,0,0.90625-3.875-0.15625-5.125     S26.2162476,38.015625,26.2162476,38.015625z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.1062622,18.2993774v28.1199951H38.15625l1.0100098,3.3800049l5.3499756-3.3800049h6.5800171V18.2993774     H35.1062622z M47.8362427,43.1693726h-3.5599976l-3.7199707,2.3800049l-0.8200073-2.3800049h-1.3800049V21.5493774h9.4799805     V43.1693726z"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZhihuIcon);
export default __webpack_public_path__ + "static/media/zhihu_icon.5302e0fe047b6f8a09ad446de342696e.svg";
export { ForwardRef as ReactComponent };